import React from "react";
import "./CTASection.css";
import { FiPhone } from "react-icons/fi";
import { IoLogoWhatsapp } from "react-icons/io5";

const CTASection = () => {
  return (
    <section className="standard-padding">
      <div className="cta-container">
        {/* Left Content */}
        <div className="cta-text">
          <h3>
            Experience Luxury Like <br className="desktop-break" />
            Never Before
          </h3>
        </div>

        {/* Right Buttons */}
        <div className="cta-buttons">
          <button
            className="cta-btn"
            onClick={() => (window.location.href = "tel:+971559886749")}
          >
            <FiPhone />
            <span> Talk to Our DMC Team</span>
          </button>

          <button
            className="cta-btn"
            onClick={() =>
              window.open(
                "https://wa.me/+971559886749?text=Hello%20I%20have%20a%20B2B%20enquiry",
                "_blank",
              )
            }
          >
            <IoLogoWhatsapp />
            <span> WhatsApp for B2B Enquiries</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
